const ApproveHeade = () => {
    return ( <div className="approve_heade">
        <div className="main-approve-title">
            <span className="material-icons">close</span>
            <h3>Approve factoring request</h3>

        </div>
    </div> );
}
 
export default ApproveHeade;